export enum Pages {
  AlSettings = '/al-settings',
  Cities = '/cities',
  CitiesV2 = '/cities-v2',
  Faq = '/faq',
  Curves = '/curves',
  LiveOps = '/live-ops',
  LiveOpsV2 = '/live-ops-v2',
  Actions = '/actions',
  RedButton = '/red-button',
  Operations = '/operations',
  Roles = '/settings/roles',
  Routes = '/settings/routes',
  SaturationRules = '/settings/saturation-rules',
  Settings = '/settings',
  Users = '/settings/users',
  Views = '/settings/views',
  Forecasting = '/forecasting',
  Forecastingv2 = '/forecastingv2',
  Error = '/error',
  ControlCenter = '/control-center',
  Simulator = '/simulator',
  CurvesOld = '/curves-old'
}
